import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl' | '6xl' | '7xl' | 'full';
  noPadding?: boolean;
}

/**
 * ページコンテンツを中央揃えで表示するコンテナコンポーネント
 * POSレジ以外の全ページで使用
 */
const PageContainer: React.FC<PageContainerProps> = ({ 
  children, 
  className = '', 
  maxWidth = '7xl',
  noPadding = false 
}) => {
  const maxWidthClasses = {
    'sm': 'max-w-sm',
    'md': 'max-w-md',
    'lg': 'max-w-lg',
    'xl': 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    'full': 'max-w-full'
  };

  return (
    <div className={`min-h-screen bg-gray-50 ${noPadding ? '' : 'p-6'}`}>
      <div className={`${maxWidthClasses[maxWidth]} mx-auto ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default PageContainer;